import * as React from 'react';
import Block from "@layout/Block";
import Font from "@layout/Font";
import { PieceTable } from '@store/index';
import ReactTable, { Column } from "react-table";
import './index.css'

interface Props {
    piece: PieceTable;
}

const TablePiece = ({ piece }: Props) => (
    <Block indent="30">
        {
            piece.title &&
            <Block indent="20">
                <div className="grid">
                    <div className="grid-6 line-bottom">
                        <Font font="primary">
                            { piece.title }
                        </Font>
                    </div>
                </div>
            </Block>
        }

        <ReactTable
            {...piece.tableProps && piece.tableProps}
            data={piece.data}
            columns={piece.header}
        />
    </Block>
);

export default TablePiece;


// WEBPACK FOOTER //
// ./src/components/layout/pieces/Table/index.tsx